let consentApiReady = false;
function googleFc() {
  const target = window;
  target.googlefc = target.googlefc || {};
  target.googlefc.callbackQueue = target.googlefc.callbackQueue || [];
  return target.googlefc;
}
export function initializeConsentApi() {
  googleFc().callbackQueue.push({
    CONSENT_API_READY: () => {
      consentApiReady = true;
      m.redraw();
    }
  });
}
export function canManageConsent() {
  return consentApiReady && typeof googleFc().showRevocationMessage === 'function';
}
export function showConsentSettings(event) {
  event?.preventDefault();
  const api = googleFc();
  if (typeof api.showRevocationMessage === 'function') {
    api.showRevocationMessage();
  }
}